module.exports = __webpack_public_path__ + "img/interest.c10fe227.png";